export enum HttpStatus {
  badRequest = 400,
  notFound = 404,
  redirect = 301,
  found = 302,
  unauthorized = 401,
  conflict = 409,
  unprocessableEntity = 422,
  tooManyRequests = 429,
  internalServerError = 500,
  success = 200,
}
